import { ref, computed } from "vue";
import { defineStore } from "pinia";
import type { IChatMessage } from "../interfaces/chatBotInterfaces";
import { v4 as createGuid } from "uuid";

export const useChatBotStore = defineStore("chatBot", () => {
  const messages = ref<Array<IChatMessage>>([]);
  const sessionId = ref<string>(createGuid());

  const messageCount = computed(() => messages.value.length);

  const isChatOpen = ref(false);

  const currentChatId = ref<string | null>(null);

  const clearHistory = () => {
    if (confirm("Are you sure you want to clear the chat history?")) {
      messages.value = [];
    }
  };

  function toggleChat() {
    isChatOpen.value = !isChatOpen.value;
  }

  function setSessionId(id: string) {
    sessionId.value = id;
  }

  return { messages, messageCount, isChatOpen, sessionId, currentChatId, clearHistory, toggleChat, setSessionId };
});
